export interface INumeroRotinaProps {
  percentualMargemVenda: number
  ordemMascaraVendedor: number
  mascaraVendedor: number
}

export class Rotina {
  static readonly montar = ({
    mascaraVendedor,
    ordemMascaraVendedor,
    percentualMargemVenda,
  }: INumeroRotinaProps): string => {
    const mascaraDoVendedorInteiro = Math.round(mascaraVendedor)
    const percentualMargemDeVendaInteiro = Math.round(percentualMargemVenda * 100)
    const anoAtual = new Date().getFullYear()

    const numeroDeRotina = [mascaraDoVendedorInteiro, anoAtual, percentualMargemDeVendaInteiro]

    if (ordemMascaraVendedor === 2) numeroDeRotina.reverse()

    return numeroDeRotina.join('.')
  }
}
